import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  conversations: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: null,
  },
};

export const conversationsSlice = createSlice({
  name: "conversations",
  initialState: INITIAL_STATE,
  reducers: {
    fetchConversationsData: (state) => {
      state.conversations.isLoading = true;
    },
    fetchConversationsSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      conversations: {
        ...state.conversations,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    updateConversationsData: (state, action: PayloadAction<any>) => ({
      ...state,
      conversations: {
        ...state.conversations,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        data: action.payload?.data,
      },
    }),
    fetchConversationsFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      conversations: {
        ...state.conversations,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
    clearConversation: (state) => ({
      ...state,
      conversations: {
        ...state.conversations,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: null,
        statusText: null,
        data: null,
      },
    }),
  },
});

export const {
  fetchConversationsData,
  fetchConversationsFailure,
  fetchConversationsSuccess,
  clearConversation,
  updateConversationsData,
} = conversationsSlice.actions;
export const conversationsReducer = conversationsSlice.reducer;
